import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WelletContext } from '../../../context/WelletContext';
import InputFormBorder from '../InputFormBorder/InputFormBorder';
import GeneralSelectorPicker from '../../SelectorPicker/GeneralSelectorPicker';
import { useSelector } from 'react-redux';

const IndustryRoleSelector = ({
  handleChange,
  selectedIndustry,
  setSelectedIndustry,
  selectedRp,
  setSelectedRp,
  selectedCity,
  setSelectedCity,
  requiresRP,
  errors,
  values,
  lang, 
  textInfo = false
}) => {
  const { t } = useTranslation();
  const [rps, setRps] = useState([]);
  const welletContext = useContext(WelletContext);
  const withoutRP = { value: '0', label: t('signUp.withOutRP') };
  const [industryOptions, setIndustryOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const marketSetupId = useSelector((state) => state?.app?.currentMarket?.marketSetupId);
  const [validRps, setValidRps] = useState([]);

  const getIndustryOptions = async () => {
    try {
      const response = await welletContext.apis.tickets.get(`/associate/activities?lang=${lang}`);
      setIndustryOptions(
        response.data.map((item) => ({ value: item.activityId, label: item.name })),
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getRP = async () => {
    try {
      const result = await welletContext.apis.tickets.get(
        `associates/GetRPs?marketId=${marketSetupId}`,
      );
      let fetchedRps = result.data.map((item) => ({ value: item.id, label: item.name }));
      fetchedRps.push(withoutRP);
      const filteredRps = fetchedRps.filter((rp) => rp.value !== '0');
      setRps(fetchedRps);
      setValidRps(filteredRps);
      if (filteredRps.length === 1) {
        setSelectedRp(filteredRps[0]);
        handleRpChange(filteredRps[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getCityOptions = async () => {
    try {
      const response = await welletContext.apis.tickets.get(
        `/associates/GetRPCities?marketId=${marketSetupId}`,
      );
      setCityOptions(response.data.map((item) => ({ value: item.rpCityId, label: item.cityName })));
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getRP();
    getIndustryOptions();
    getCityOptions();
  }, []);

  const handleIndustryChange = (selectedOption) => {
    setSelectedIndustry(selectedOption);
    handleChange({
      target: { name: 'activityId', value: selectedOption.value },
      persist: () => {},
    });
  };

  const handleRpChange = (selectedOption) => {
    if (selectedOption.value !== '0') values.cityId = null;
    setSelectedRp(selectedOption);
    handleChange({
      target: { name: 'rpId', value: selectedOption.value },
      persist: () => {},
    });
    handleChange({
      target: { name: 'cityId', value: null },
      persist: () => {},
    });
  };

  const hasNoRp = selectedRp.value === '0';

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
    handleChange({
      target: { name: 'cityId', value: selectedOption.value },
      persist: () => {},
    });
  };

  return (
    <>
      <div>
        <InputFormBorder
          name='company'
          placeholder={t('signUp.companyPlaceholder')}
          value={values.company}
          error={errors.company}
          label={t('signUp.company')}
          onChange={handleChange}
          type='text'
        />
      </div>
      <div style={{ marginBottom: '.75rem' }}>
        <GeneralSelectorPicker
          options={industryOptions}
          selectedValue={selectedIndustry}
          onChange={handleIndustryChange}
          placeholder={t('signUp.sector')}
        />
        {errors.activityId && (
          <div className='error-label text-center' style={{ position: 'relative' }}>
            {errors.activityId}
          </div>
        )}
      </div>

      <div>
        <InputFormBorder
          name='role'
          placeholder={t('signUp.role')}
          value={values.role}
          label='Rol'
          error={errors.role}
          onChange={handleChange}
          type='text'
        />
      </div>

      {requiresRP && validRps.length > 1 && (
        <div className='mt-4'>
          {textInfo && <div className='fw-semibold text-primary font-tiny mt-4 mb-3 pl-1'>
            {t('informationRP')}
          </div>}
          
          {rps.length > 1 && (
            <>
              <GeneralSelectorPicker
                options={rps}
                selectedValue={selectedRp}
                onChange={handleRpChange}
                placeholder={t('selectRp')}
              />
              {errors.rpId && (
                <div className='error-label text-center' style={{ position: 'relative' }}>
                  {errors.rpId}
                </div>
              )}
            </>
          )}
        </div>
      )}
      {hasNoRp && (
        <div className='mt-25'>
          <>
            <GeneralSelectorPicker
              options={cityOptions}
              selectedValue={selectedCity}
              onChange={handleCityChange}
              placeholder={t('signUp.selectCity')}
            />
            {errors.cityId && (
              <div className='error-label text-center' style={{ position: 'relative' }}>
                {errors.cityId}
              </div>
            )}
          </>
        </div>
      )}
    </>
  );
};
export default IndustryRoleSelector;
